export var GiftCardErrorCode;
(function (GiftCardErrorCode) {
    GiftCardErrorCode["EVENTS_GIFT_CARD_NOT_FOUND"] = "EVENTS_GIFT_CARD_NOT_FOUND";
    GiftCardErrorCode["EVENTS_GIFT_CARD_INSUFFICIENT_FUNDS"] = "EVENTS_GIFT_CARD_INSUFFICIENT_FUNDS";
    GiftCardErrorCode["EVENTS_GIFT_CARD_DISABLED"] = "EVENTS_GIFT_CARD_DISABLED";
    GiftCardErrorCode["EVENTS_GIFT_CARD_EXPIRED"] = "EVENTS_GIFT_CARD_EXPIRED";
    GiftCardErrorCode["CUSTOM_ERROR_UNKNOWN"] = "CUSTOM_ERROR_UNKNOWN";
})(GiftCardErrorCode || (GiftCardErrorCode = {}));
export const getValidGiftCardDetails = (giftCardPaymentDetails) => giftCardPaymentDetails?.filter(({ voided }) => !voided);
//# sourceMappingURL=gift-cards.js.map